import { render, staticRenderFns } from "./KT-ResumeEducation.vue?vue&type=template&id=5b802cae&scoped=true&lang=pug&"
import script from "./KT-ResumeEducation.vue?vue&type=script&lang=js&"
export * from "./KT-ResumeEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b802cae",
  null
  
)

export default component.exports